import React from 'react';

const Vue_Composition_API = () => {
  return (
    <div>
      <h1>Vue_Composition_API Component</h1>
      <p>This is the Vue_Composition_API tutorial page.</p>
    </div>
  );
}

export default Vue_Composition_API;
